var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "button",
      {
        staticClass:
          "view-options-button gds-button gds-compact gds-button-outline",
        attrs: { title: "Options" },
        on: {
          click: function($event) {
            return _vm.viewOptions()
          }
        }
      },
      [
        _c("svg", { staticClass: "gds-icon shift-left" }, [
          _c("use", {
            attrs: {
              "xlink:href":
                "/wp-content/themes/gmptwentynineteen/assets/symbol-defs.svg#gds-icon-settings"
            }
          })
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.viewOptionsLabel))])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }